export const locationSelectAllValue = {
  facility_id: null,
  facility_name: null,
  id: 'all',
  name: 'All Facilities',
  level_name: 'allFacilities',
};
